<template>
  <z-modal
    width="530px"
    class="my-interest"
    :loading="loading"
    :visible.sync="visible"
    v-on="$listeners"
    buttonText="保存"
    @submit="save"
    @close="close"
  >
    <template slot="title">
      <div class="interest_title">
        <span class="font-16 font-bold mr-2">设置我的兴趣</span>
      </div>
    </template>
    <div class="box_list">
      <div
        class="box"
        :class="{ box_active: box.interest }"
        v-for="(box, index) in boxList"
        :key="box.code"
        @click="boxClick(box, index)"
      >
        <div style="display: flex; align-items: center; ;">
          <SvgIcon
            style="width: 26px; height: 26px; margin-right: 12px"
            :iconClass="box.svgIcon || ''"
          />
          <p style="margin-bottom: 0;">{{ box.title }}</p>
        </div>
        <SvgIcon
          style="width: 18px; height: 18px;"
          :iconClass="box.interest ? 'check-circle-filled' : 'check-circle-empty'"
        />
      </div>
      <!-- <div style="width: 100px;" v-for="item in 3" :key="item + '-'"></div> -->
    </div>
  </z-modal>
</template>
<script>
import SvgIcon from '@/components/SvgIcon'
import zModal from '@/components/ZModal'
import { setClassesTypes, getClassesTypes } from '@/api/user'
export default {
  name: 'InterestModal',
  components: {
    zModal,
    SvgIcon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      visible: this.value,
      boxList: [],
      originActiveList: [],
      svgDict: {
        建筑培训: 'building',
        教师培训: 'notebook',
        办公软件培训: 'briefcase',
        学历培训: 'doctorialhat',
        会计培训: 'coin',
        设计培训: 'notecard'
      }
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        this.getClassesTypesAsync()
       }
    }
  },
  computed: {
    activeList () {
      const arr = this.boxList.filter(item => item.interest).map(item => item.code)
      // console.log('arr.map(item => item.code)', arr.map(item => item.code))
      return arr
    }
  },

  created () {
    // this.getClassesTypesAsync()
  },
  methods: {
    async getClassesTypesAsync () {
      try {
        const res = await getClassesTypes()
        this.boxList =
          Array.isArray(res) &&
          res.map(v => {
            return {
              ...v,
              svgIcon: this.svgDict[v.title] || ''
            }
          })
        this.originActiveList = JSON.parse(JSON.stringify(this.boxList))
      } catch (error) {
        console.log(error)
      }
    },
    // async setClassesTypesAsync() {
    //   try {
    //     const res
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    async save () {
      try {
        this.loading = true
        await setClassesTypes(this.activeList)
        // console.log('res', res)
        this.$emit('save', this.boxList)
        this.hide()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    close () {
      this.boxList = JSON.parse(JSON.stringify(this.originActiveList))
      this.hide()
    },
    hide () {
      this.visible = false
      this.$emit('update:value', false)
    },
    boxClick (data, index) {
      const interest = this.boxList[index].interest
      if (this.activeList.length >= 6) {
        interest && (this.boxList[index].interest = false)
        return
      }
      this.boxList[index].interest = !interest
    }
  }
}
</script>
<style lang="less" scoped>
.my-interest {
  /deep/ .ant-modal-content {
    border-radius: 4px;
  }
}
.interest_title {
  display: flex;
  align-items: center;
  // h3 {
  //   font-size: 17px;
  //   margin-right: 20px;
  // }
  // span {
  //   font-size: 15px;
  //   color: #aeb5c5;
  // }
}
.box_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 12px;
  margin-bottom: 10px;
  // margin-top: 32px;
  .box {
    box-sizing: border-box;
    padding: 0 21px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 227px;
    height: 54px;
    border-radius: 4px;
    border: 1px solid #dcdee1;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 20px;
    transition: all 0.3s;
  }
  // .box_active {
  //   color: #4b7dfd;
  //   border-color: #4b7dfd;
  // }
}
</style>
